import { cn } from '@/utils/cn';

/**
 * Horizontal rules only, matching the letter-detail rows inside their frame.
 * One column below `sm`, two from `sm`, four from `lg`. The last row at each
 * width has no bottom rule, so the inner frame reads as one card.
 */
export function referralOverviewRuleClass(index: number, count: number): string {
  if (count <= 0 || index < 0 || index >= count - 1) return '';
  const lastRowAt = (columns: number) => {
    const remainder = count % columns;
    const lastRowSize = remainder === 0 ? columns : remainder;
    return index >= count - lastRowSize;
  };
  return cn(
    'border-b border-ds-line',
    lastRowAt(2) && 'sm:border-b-0',
    lastRowAt(4) && 'lg:border-b-0',
  );
}
